import Api from "./Api";
import Csrf from "./Csrf";
import axios from "axios";

export default {
  async register(form) {
    await Csrf.getCookie();

    return Api.post("/register", form);
  },

  async login(form) {
    await Csrf.getCookie();

    return Api.post("/login", form);
  },

  async logout() {
    await Csrf.getCookie();

    return Api.post("/logout");
  },

  auth() {
    return Api.post("/user");
  }, 
	
  async updateSelf(form) {
    await Csrf.getCookie();

    return Api.patch("/user_self", form);
  },
    
  async update(id,form) {
    await Csrf.getCookie();

    return Api.patch("/users/"+id, form);
  },
    
  async updateDetails(id,form) {
    await Csrf.getCookie();

    return Api.patch("/users/"+id+'/details', form);
  },
    
  async updateAdmin(id,form) {
    await Csrf.getCookie();

    return Api.patch("/users/"+id+'/admin', form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/users");
  },
    
  async wizardGuests() {
    await Csrf.getCookie();

    return Api.get("/wizard-guests");
  },
    
  async toggleActive(id) {
    await Csrf.getCookie();

    return Api.get("/users/"+id+"/toggle-active");
  },
    
  async getRole(role_id) {
    await Csrf.getCookie();

    return Api.get("/users/role/" + role_id);
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/users", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/users/" + id);      
      
  },
	
	async show(id) {
		await Csrf.getCookie();

		return Api.get("/users/" + id );      

  },
	
	async bookings(id) {
		await Csrf.getCookie();

		return Api.get("/users/" + id + '/bookings');      

  },
	checkOnlineStatus(timestamp,project_id,lszsz,device_id){
		return axios.post("https://countit.dwshungary.hu/tc26api/get-finished-places/"+timestamp,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
	
	
	async setPassword(form) {
    await Csrf.getCookie();

    return Api.patch("/change_password", form);
  },
	
	
async logs(id,event_id = null){
		await Csrf.getCookie();
		
		if(event_id == null){
			return Api.get('/users/'+ id + '/logs');	
		}else{
			return Api.get('/users/'+ id + '/logs/' +event_id);
		}
	},

	
};